const body = document.querySelector("body");
let scrollPosition = 0;

export default {
    enable() {
        scrollPosition = window.pageYOffset;
        body.style.overflow = "hidden";
        body.style.position = "fixed";
        body.style.top = `-${scrollPosition}px`;
        body.style.width = "100%";
    },
    disable() {
        body.style.removeProperty("overflow");
        if (body.classList.contains("fp-responsive")) {
            body.style.overflow = "visible";
        }
        body.style.removeProperty("position");
        body.style.removeProperty("top");
        body.style.removeProperty("width");
        window.scrollTo(0, scrollPosition);
    }
};
